import { PlusOutlined } from "@ant-design/icons";
import { Divider, Input, Select, Space, Button, Form } from "antd";
import React, { useState,useEffect, useRef } from "react";
import { getColorHex, extractColorName, normalizeHexColor } from "../../utils/identifyColor";
const { Option } = Select;
let index = 0;

// Helper function to format quantity: max 4 decimal places, remove trailing zeros
const formatQuantity = (qty) => {
  if (qty === null || qty === undefined || qty === "" || qty === "-") return qty;
  
  const num = typeof qty === 'number' ? qty : parseFloat(qty);
  if (isNaN(num) || !isFinite(num)) return qty;
  
  // Round to 4 decimal places and remove trailing zeros
  const rounded = Math.round(num * 10000) / 10000;
  // Convert to string and remove trailing zeros and decimal point if not needed
  return rounded.toString().replace(/\.?0+$/, '');
};

// const SelectType = ({ options, name,value,label }) => {
const SelectType = (props) => {
  // console.log("options", options);
  const [items, setItems] = useState(props.options);
  const [_name, setName] = useState("");
  const inputRef = useRef(null);
  const selectRef = useRef(null);
// console.log(props.options)
  const handleChange = (value) => {
    const nextValue = (() => {
      if (isColorSelector) {
        const normalized = normalizeHexColor(value);
        return normalized || value;
      }
      return value;
    })();
    if (typeof props.value === "function") {
      props.value(nextValue);
    } else {
      console.warn("props.value is not a function");
    }
  };

  const isOptionObject = (opt) => opt !== null && typeof opt === "object";
  const getOptionValue = (opt) => {
    if (isOptionObject(opt)) return opt.value ?? opt.label ?? "";
    return opt;
  };
  const getOptionLabel = (opt) => {
    if (isOptionObject(opt)) return opt.label ?? opt.value ?? "";
    return opt;
  };
  const getOptionQty = (opt) => {
    if (isOptionObject(opt)) return opt.qty ?? opt.quantity ?? null;
    return null;
  };


 useEffect(() => {
setItems(props.options)
 }, [props.options]);

  //  console.log(props.options)
  //  setItems(props.options)
  //  console.log(items)
     
    
  const onNameChange = (e) => {
    setName(e.target.value);
    // console.log(number);
  };

  const addItem = (e) => {
    e.preventDefault();
    setItems([...(items || []), _name || `New item ${index++}`]);
    setName("");
    console.log(_name)
  };
  // setInterval(() => {
  //  console.log(number);
  // }, 5000);

  // Check if this is a color selector
  const isColorSelector = props.label && props.label.toLowerCase().includes('color');

  // Custom filter function for better search functionality
  // This searches the actual option value and label text, not the JSX children
  const filterOption = (input, option) => {
    if (!input) return true;
    const searchText = input.toLowerCase().trim();
    
    // Get the option value and label from the option props
    const optionValue = String(option?.value || '').toLowerCase();
    const optionLabel = String(option?.label || option?.value || '').toLowerCase();
    
    // Search in both value and label (case-insensitive)
    const matchesValue = optionValue.includes(searchText);
    const matchesLabel = optionLabel.includes(searchText);
    
    // For color selectors, also search in the extracted color name (without codes)
    let matchesColorName = false;
    if (isColorSelector) {
      const colorName = extractColorName(option?.label || option?.value || '').toLowerCase();
      matchesColorName = colorName.includes(searchText);
    }
    
    return matchesValue || matchesLabel || matchesColorName;
  };

  return (
    <Form.Item name={props.name} label={props.label}
    rules={[
      {
        required: props.required,
        message: "Required Field!",
      },
    ]} >
      <Select
      // defaultValue={number}
      onSelect={handleChange}
      // value={"number"}
      // value={"SDF"}
      // onSelect={"sdf?"}
        // aria-selected={"sd"}
        placeholder={`Select ${props.label}`}
        ref={selectRef}
        style={{ width: "100%" }}
        showSearch
        filterOption={filterOption}
        allowClear
        // onSelect does not fire on clear; let the parent drop the selection too
        onClear={() => {
          if (typeof props.onClear === "function") props.onClear();
        }}
        dropdownMatchSelectWidth

        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider
              style={{
                margin: "8px 0",
              }}
            />
            <Space
              style={{
                padding: "0 8px 4px",
              }}
            >
              <Input
                placeholder={`Please enter manual ${props.label}`}
                ref={inputRef}
                value={_name}
                onChange={onNameChange}
              />
              <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                Add {props.label}
              </Button>
            </Space>
          </>
        )}>
        {items && items.map((item) => {
          const optionValue = getOptionValue(item);
          const optionLabel = getOptionLabel(item);
          const optionQty = getOptionQty(item);

          if (isColorSelector) {
            // Get hex color prioritizing color_code if available in option object
            const colorData = item?.color_code ? { color_code: item.color_code, color: optionLabel || optionValue } : { color: optionLabel || optionValue };
            const hexColor = getColorHex(colorData);
            const displayText = (() => {
              const txt = optionLabel || optionValue;
              const normalized = normalizeHexColor(txt);
              return normalized || txt;
            })();

            return (
              <Option key={optionValue} value={optionValue} label={displayText}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {displayText}
                    </span>
                    {optionQty !== null && optionQty !== undefined && optionQty !== "" ? (
                      <span style={{ fontSize: 11, color: "#6b7280", whiteSpace: "nowrap" }}>
                        Qty: {formatQuantity(optionQty)}
                      </span>
                    ) : null}
                  </div>
                  {hexColor ? (
                    <div
                      style={{
                        width: 40,
                        height: 28,
                        backgroundColor: hexColor,
                        border: hexColor.toLowerCase() === '#ffffff' || hexColor.toLowerCase() === '#fff' ? '1px solid #d9d9d9' : 'none',
                        borderRadius: 4,
                        flexShrink: 0,
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 28,
                        height: 28,
                        backgroundColor: '#f0f0f0',
                        border: '1px solid #d9d9d9',
                        borderRadius: 4,
                        flexShrink: 0,
                      }}
                    />
                  )}
                </div>
              </Option>
            );
          }

          return (
            <Option key={optionValue} value={optionValue} label={optionLabel || optionValue}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {optionLabel || optionValue}
                </span>
                {optionQty !== null && optionQty !== undefined && optionQty !== "" ? (
                  <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap' }}>
                    Qty: {formatQuantity(optionQty)}
                  </span>
                ) : null}
              </div>
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default SelectType;














